import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { AxiosError } from 'axios'

type RecoverPasswordBody = {
  email?: string
  tax_id?: string
  use_second_provider?: boolean
}

type RecoverPasswordResponse = {
  masked_email: string
}

export async function recoverPassword(body: RecoverPasswordBody) {
  const response = await httpClient(
    'user-manager',
  ).post<RecoverPasswordResponse>('/v1/user/password/recover', body)

  return response.data
}

export function useRecoverPassword(
  options?: UseMutationOptions<
    RecoverPasswordResponse,
    AxiosError,
    RecoverPasswordBody,
    unknown
  >,
) {
  return useMutation({
    mutationFn: recoverPassword,
    ...options,
  })
}
